import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQSection = ({ page }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/faqs?page=${page}`).then((r) => setItems(r.data));
  }, [page]);

  if (!items.length) return null;

  return (
    <section className="py-24 md:py-32" data-testid={`faqs-${page}`}>
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <p className="text-xs uppercase tracking-[0.25em] text-ahm-orange font-semibold mb-4">FAQ</p>
            <h2 className="font-display text-5xl md:text-6xl leading-[0.95] text-ahm-teal text-balance">
              Things people <em className="not-italic text-ahm-orange">ask us</em> a lot.
            </h2>
          </div>
          <div className="md:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {items.map((it, i) => (
                <AccordionItem key={it.id} value={`q-${i}`} className="border-b border-ahm-teal/15">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${page}-${i}`}
                    className="text-left font-display text-2xl md:text-3xl text-ahm-teal hover:text-ahm-orange py-6"
                  >
                    {it.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-base md:text-lg text-ahm-teal/80 leading-relaxed pb-6">
                    {it.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
